import { render, staticRenderFns } from "./LiabilityMortgageMortgage.vue?vue&type=template&id=5372c196"
import script from "./LiabilityMortgageMortgage.vue?vue&type=script&lang=js"
export * from "./LiabilityMortgageMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports